var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReelaxTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "527px",
    height: "522px",
    viewBox: "0 0 527 522",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.538,60 L454.288308,186.74862 L453.78,187.103 L453.864815,187.162633 L355.249,327.999741 L277.12,327.999741 L376.092,186.653 L287.409,60 L365.538,60 Z",
    id: "Combined-Shape",
    fill: "#48CEA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.552493,200 L247.445493,339.806 L249.38263,341.162633 L159.868815,468.999741 L81.7408148,468.999741 L170.759493,341.867 L71.4234935,200 L149.552493,200 Z",
    id: "Combined-Shape-Copy",
    fill: "#48CEA2",
    transform: "translate(160.403062, 334.499871) rotate(180.000000) translate(-160.403062, -334.499871) "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelaxTicket);
export default __webpack_public_path__ + "static/media/reelax-ticket.1d73c18e.svg";
export { ForwardRef as ReactComponent };